module.exports = __webpack_public_path__ + "img/img-69.16836a05.png";